import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Brand } from "./Logo";

const LINKS = [
  { to: "/services", label: "Services" },
  { to: "/approach", label: "Approach" },
  { to: "/experience", label: "Experience" },
  { to: "/process", label: "Process" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/85 border-b border-slate-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" onClick={() => setOpen(false)}>
          <Brand />
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `relative font-mono text-xs uppercase tracking-[0.18em] transition-colors duration-200 after:absolute after:-bottom-1.5 after:left-0 after:h-px after:bg-amber-400 after:transition-all after:duration-300 ${
                  isActive ? "text-blue-700 after:w-full" : "text-slate-500 hover:text-[#0A1F44] after:w-0 hover:after:w-full"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-discuss-role-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-amber-400 text-[#0A1F44] font-semibold text-sm px-5 py-2.5 transition-transform duration-200 hover:scale-[1.04] active:scale-95"
          >
            Discuss a role
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </nav>

        <button
          className="md:hidden text-[#0A1F44] p-2"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="md:hidden overflow-hidden border-t border-slate-200 bg-white/95"
            data-testid="mobile-nav"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                  className="font-display text-xl font-bold text-[#0A1F44]"
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                onClick={() => setOpen(false)}
                data-testid="mobile-nav-discuss-role-btn"
                className="inline-flex w-fit items-center gap-2 rounded-full bg-amber-400 text-[#0A1F44] font-semibold text-sm px-5 py-2.5"
              >
                Discuss a role <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
